<template>
  <div class="template-form-compact">
    <div class="form-section">
      <h6 class="section-title">Обробляємі сторони</h6>
      <div class="input-grid">
        <div class="input-group">
          <label for="p1">За довжиною</label>
          <select id="p1" :class="{ 'red': detailValidation('P1_') }" v-model.number="detail.p1">
            <option value="0">Не обробляти</option>
            <option value="1">Одна</option>
            <option value="2">Дві</option>
          </select>
          <div v-if="detailValidation('P1_')" class="error-message">
            {{ detailValidationText('P1_') }}
          </div>
        </div>

        <div class="input-group">
          <label for="p2">За шириною</label>
          <select id="p2" :class="{ 'red': detailValidation('P2_') }" v-model.number="detail.p2">
            <option value="0">Не обробляти</option>
            <option value="1">Одна</option>
            <option value="2">Дві</option>
          </select>
          <div v-if="detailValidation('P2_')" class="error-message">
            {{ detailValidationText('P2_') }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-section-full">
      <div class="input-group">
        <label for="edge_template">Оклеювання кромкою</label>
        <select id="edge_template" class="custom-select edge" :style="getEdgeSelectStyle(detail.edge_template)"
          :class="{ 'red': detailValidation('EdgeA1_') }" v-model="detail.edge_template">
          <option :value="null">Ні</option>
          <option v-for="(edge, i) in edges" :value="edge.ref" :key="i">
            {{ (i + 1) + ' ' }} {{ edge.full_name }}
          </option>
        </select>
        <div v-if="detailValidation('EdgeA1_')" class="error-message">
          {{ detailValidationText('EdgeA1_') }}
        </div>
      </div>

      <div class="input-group">
        <label for="file">Файл</label>
        <input ref="fileInput" type="file" id="file" accept="image/*" @change="handleFileChange"
          class="file-input-hidden" />
        <button v-if="!detail.attachment && !localFile" type="button" class="file-add" @click="$refs.fileInput.click()">
          <i class="fa fa-paperclip"></i>
          <span>Додати файл</span>
        </button>
        <div v-if="detail.attachment || localFile" class="file-info">
          <i class="fa fa-file-image"></i>
          <span>{{ detail.attachment ? detail.attachment.file_name : (localFile ? localFile.name : '') }}</span>
          <button type="button" @click="removeFile" class="file-remove">
            <i class="fa fa-times"></i>
          </button>
        </div>

      </div>
    </div>

    <div class="form-section">
      <div class="input-group">
        <label for="note">Примітка</label>
        <input id="note" v-model="detail.note" placeholder="Введіть примітку..." />
      </div>
    </div>
  </div>
</template>

<script>
import validation from "@/mixins/BaseTemplate"

export default {
  mixins: [validation],
  props: [
    'edges',
    'detail'
  ],
  data() {
    return {
      localFile: null,
    }
  },
  methods: {
    getEdgeSelectStyle(edgeRef) {
      const edge = this.edges.find(m => m.ref === edgeRef);
      if (edge && edge.color) {
        const contrastColor = this.getContrastColor(edge.color);
        return {
          backgroundColor: edge.color,
          color: contrastColor,
          borderColor: contrastColor,
        };
      }
      return {};
    },

    // Метод для получения контрастного цвета
    getContrastColor(hexColor) {
      if (!hexColor) return '#000000';

      // Убираем # если есть
      const hex = hexColor.replace('#', '');

      // Конвертируем в RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Вычисляем яркость
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Возвращаем белый для темных цветов, черный для светлых
      return brightness > 128 ? '#000000' : '#ffffff';
    },

    // Метод для обработки файлов
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.localFile = file;
        this.detail.file = file; // якщо потрібно надалі
      }
    },

    // Метод для удаления файла
    removeFile() {
      this.localFile = null;
      this.detail.file = null;
      this.detail.attachment = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    }
  },
  computed: {
    resp() {
      return this.$store.state.data.response;
    },
  },
  watch: {
    detail: function (newValue, oldValue) {
      this.$root.$emit('update-detail', this.detail);
    }
  },
  name: "Template_6"
}
</script>

<style scoped>
/* Фиксируем высоту селекта кромки */
.custom-select.edge {
  height: 2.5rem;
  min-height: 2.5rem;
  max-height: 2.5rem;
}

/* Красивый триггер добавления файла */
.file-input-hidden {
  display: none;
}

.file-add {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  height: 2.5rem;
  border: 2px dashed #dee2e6;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.85rem;
  width: 100%;
}

.file-add:hover {
  border-color: #ff182d;
  background-color: rgba(255, 24, 45, 0.05);
  color: #ff182d;
}

/* Стили для отображения файла */
.file-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 0.375rem;
  font-size: 0.85rem;
  color: #1976d2;
  height: 2.5rem;
  width: 100%;
}

.file-info i {
  font-size: 1rem;
}

.file-remove {
  margin-left: auto;
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease;
}

.file-remove:hover {
  background-color: rgba(220, 53, 69, 0.1);
}
</style>
